import CustomSelect from '@/components/CustomSelect'
import CustomTabs from '@/components/CustomTabs'
import SSelect from '@/components/SSelect'

const children = (h, el) => {
    let ch = el.childNodes
    let chds = []
    let con
    for(let i=0; i<ch.length; i++) {
	if(Node.ELEMENT_NODE == ch[i].nodeType)
	    con = h('simple-element',
		    { props: { el: ch[i]}} )
	else if(Node.TEXT_NODE == ch[i].nodeType)
	    con = ch[i].textContent
	else
	    continue;
	chds.push(con)
    }
    // console.log(chds)
    return chds
}
const simpleEl = {
    name: 'simple-element',
    props: ['el'],
    render(h) {
	let el = this.$props.el
	//console.log(el.nodeName)
	if(Node.ELEMENT_NODE == el.nodeType) {
	    let at = el.attributes
	    let attrs = {}
	    //let slot = ''
	    for(let i=0; i<at.length; i++) {
		//console.log(at[i].name)
		attrs[at[i].name] = at[i].value
		//if("slot" == at[i].name)
		//    slot = at[i].value
	    }
	    /*
	    let ch = el.childNodes
	    let child = []
	    let con
	    for(let i=0; i<ch.length; i++) {
		if(Node.ELEMENT_NODE == ch[i].nodeType)
		    con = h('simple-element',
			  { props: { el: ch[i]}} )
		else
		    con = ch[i].textContent
		child.push(con)
	    }
	    */
	    let props = {}
	    let nodeName = el.nodeName.toLowerCase()
	    if("note" == nodeName) {
		nodeName = "div"
		attrs["style"] = "margin-top: 5px;"
		attrs["class"] = "note"
	    } else if("custom-select" == nodeName ||
		      "custom-tabs" == nodeName ) {
		props['el'] = el
		/*
		return h(
		    nodeName,
		    { props: props }
		)
		*/
	    } else if("select" == nodeName) {
		nodeName = "s-select"
		props['el'] = el
	    }
	    /*
	    else if("select" == nodeName) {
		if(!('name' in attrs)) {
		    //console.debug("store", store)
		    attrs["name"] = "option_"+select_counter.counter
		    // console.debug("name", el, attrs["name"])
		    select_counter.countUp()
		}
	    }
	    */
	    /*
	    else if("loop" == nodeName) {
		props["count"] = attrs["count"]
		props['el'] = el
	    }
	    */
	    return h(
		nodeName,
		{
		    attrs: attrs,
		    props: props,
		    //slot: slot
		},
		children(h,el)
	    )
	} else if(Node.TEXT_NODE == el.nodeType) {
	    // plain text nodeを生成する場合は、this._vを使うらしい...
	    return this._v(el.textContent)
	}
    },
    components: {
	'custom-select': CustomSelect,
	'custom-tabs': CustomTabs,
	's-select': SSelect
    }
}

CustomSelect.components['simple-element'] = simpleEl
CustomSelect.components['s-select'] = SSelect
CustomTabs.components['simple-element'] = simpleEl
//CustomSelect.components['s-select'] = SSelect

export default simpleEl



// WEBPACK FOOTER //
// ./src/components/SimpleElement.js